import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

import {cleaningRequestService} from "../../services/cleaningRequest.service";
import {orderService} from "../../services/order.service";
import {axiosService} from "../../services/axios.service";
import {endPoints} from "../../configs/urls";

const initialState = {
    allCleaningRequests: [],
    status: '',
    order: {},
    activeCleaningRequestsByCurrentUser: [],
    filteredCleaningRequests: [],
    historyCleaningRequests: [],
    // allCleaningRequestsByCurrentUser: [],
    cleanerApplicationsByCurrentCleaner: [],
    alreadyAppliedCleaningRequestsByCurrentCleaner: [],
    notAppliedCleaningRequestsByCurrentCleaner: [],
    // cleanerApplicationsByCleaningRequest: [],
    totalItems: null,
    error: null,
}

// const getAllByCurrentUser = createAsyncThunk(
//     'cleaningRequestsSlice/getActiveByCurrentUser',
//     async () => {
//         try {
//             const {data} = await cleaningRequestService.getByCurrentUser();
//
//             return data;
//         } catch (error) {
//             console.log(error);
//             throw error;
//         }
//     }
// );


const getActiveByCurrentUser = createAsyncThunk(
    'cleaningRequestsSlice/getActiveByCurrentUser',
    async () => {
        try {
            const {data} = await axiosService.get(`${endPoints.cleaningRequest.byCurrentUser}?status=CREATED&status=APPROVED-BY-CLEANER`);

            return data;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
);

const getHistoryByCurrentUser = createAsyncThunk(
    'cleaningRequestsSlice/getHistoryByCurrentUser',
    async () => {
        try {
            // const params = {status: "CANCELED"};
            // const {data} = await cleaningRequestService.getByCurrentUser(params);
            const {data} = await axiosService.get(`${endPoints.cleaningRequest.byCurrentUser}?status=FINISHED&status=CANCELED`);

            return data;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
);

const getCleanerApplicationsByCleaningRequest = createAsyncThunk(
    'cleaningRequestsSlice/getCleanerApplicationsByCleaningRequest',
    async ({id}) => {
        try {
            const {data} = await axiosService.get(`${endPoints.application.base}${id}/applications-by-request/`);

            return data.results;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
);

const getById = createAsyncThunk(
    'cleaningRequestsSlice/getById',
    async ({id}) => {
        try {
            const {data} = await cleaningRequestService.getById(id);

            return data;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
);

const deleteById = createAsyncThunk(
    'cleaningRequestsSlice/deleteById',
    async ({id}) => {
        try {
            const {data} = await cleaningRequestService.deleteById(id);
            console.log(id, 'id')
            return id;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
);

const updateById = createAsyncThunk(
    'cleaningRequestsSlice/updateById',
    async ({id, data}) => {
        try {
            const {data: res_data} = await cleaningRequestService.updateById(id, data);

            return res_data;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
);

const getActiveCleaningRequests = createAsyncThunk(
    'cleaningRequestsSlice/getActiveCleaningRequests',
    async ({page}) => {
        try {
            const params = {status: "CREATED", page}
            const {data} = await cleaningRequestService.getFiltered(params);

            return data;
        } catch (error) {
            throw error;
        }
    }
);

const getFilteredActiveCleaningRequests = createAsyncThunk(
    'cleaningRequestsSlice/getFilteredActiveCleaningRequests',
    async ({params}) => {
        try {
            const {data} = await cleaningRequestService.getFiltered(params);

            return data;
        } catch (error) {
            throw error;
        }
    }
);

const cleaningRequestsSlice = createSlice({
    name: 'cleaningRequestsSlice',
    initialState,
    reducers: {
        setStatus: (state, action) => {
            state.status = action.payload;
        },
        deleteActiveCleaningRequestByCurrentUserById: (state, action) => {
            console.log(action.payload, 'action.payload')
            console.log(state.activeCleaningRequestsByCurrentUser, 'state')
            state.activeCleaningRequestsByCurrentUser = state.activeCleaningRequestsByCurrentUser.filter((order) => order.pk !== action.payload);
        },
        clearError: (state, action) => {
            state.error = null;
        }
    },
    extraReducers: builder => builder
        .addCase(deleteById.fulfilled, (state, action) => {
            state.status = 'success';

            const id = action.payload;
            state.ordersByCurrentUser = state.ordersByCurrentUser?.filter((order) => order.pk !== id);
        })
        .addCase(deleteById.pending, (state, action) => {
            state.status = 'loading';
        })

        .addCase(getActiveByCurrentUser.fulfilled, (state, action) => {
            state.activeCleaningRequestsByCurrentUser = action.payload;

            state.status = 'success';
        })
        .addCase(getActiveByCurrentUser.pending, (state, action) => {
            state.status = 'loading';
        })

        .addCase(getHistoryByCurrentUser.fulfilled, (state, action) => {
            console.log(action.payload, 'PAYLOAD')
            state.historyCleaningRequests = action.payload;

            state.status = 'success';
        })
        .addCase(getHistoryByCurrentUser.pending, (state, action) => {
            state.status = 'loading';
        })

        .addCase(getCleanerApplicationsByCleaningRequest.fulfilled, (state, action) => {
            state.cleanerApplicationsByCleaningRequest = action.payload;

            state.status = 'success';
        })
        .addCase(getCleanerApplicationsByCleaningRequest.pending, (state, action) => {
            state.status = 'loading';
        })

        .addCase(getActiveCleaningRequests.fulfilled, (state, action) => {
            const {results, count} = action.payload;

            state.allCleaningRequests = results;
            state.totalItems = count;

            state.status = 'success';
        })
        .addCase(getActiveCleaningRequests.pending, (state, action) => {
            state.status = 'loading';
        })

        .addCase(getFilteredActiveCleaningRequests.fulfilled, (state, action) => {
            // const {results, count} = action.payload;
            //
            // state.filteredCleaningRequests = results;
            // state.totalItems = count;
            //
            // state.status = 'success';
            const {results, count} = action.payload;
            console.log(count)

            state.allCleaningRequests = results;
            state.totalItems = count;

            state.status = 'success';
        })
        .addCase(getFilteredActiveCleaningRequests.pending, (state, action) => {
            state.status = 'loading';
        })
        .addCase(getFilteredActiveCleaningRequests.rejected, (state, action) => {
            // state.status = 'success';
            state.error = 'invalid page';
        })

        .addCase(getById.fulfilled, (state, action) => {
            state.order = action.payload;

            state.status = 'success';
        })
        .addCase(getById.pending, (state, action) => {
            state.status = 'loading';
        })
});

const {actions, reducer: cleaningRequestsReducer} = cleaningRequestsSlice;

const cleaningRequestsActions = {
    ...actions,
    getActiveCleaningRequests,
    // getAllByCurrentUser,
    getById,
    updateById,
    deleteById,
    getCleanerApplicationsByCleaningRequest,
    getFilteredActiveCleaningRequests,
    getActiveByCurrentUser,
    getHistoryByCurrentUser
}

export {
    cleaningRequestsReducer,
    cleaningRequestsActions,
}
